import Immutable from 'immutable';
const LOAD = 'practices/LOAD';
const LOAD_SUCCESS = 'practices/LOAD_SUCCESS';
const LOAD_FAIL = 'practices/LOAD_FAIL';
const LOAD_WEATHER_SUCCESS = 'practices/LOAD_WEATHER_SUCCESS';
const LOAD_WEATHER_FAIL = 'practices/LOAD_WEATHER_FAIL';
const LOAD_OPENING_HOURS_SUCCESS = 'practices/LOAD_OPENING_HOURS_SUCCESS';
const LOAD_OPENING_HOURS_FAIL = 'practices/LOAD_OPENING_HOURS_FAIL';
const LOAD_PRACTICE_LIST_DIFF_SUCCESS = 'practices/LOAD_PRACTICE_LIST_DIFF_SUCCESS';
const LOAD_PRACTICE_LIST_DIFF_FAIL = 'practices/LOAD_PRACTICE_LIST_DIFF_FAIL';
const LOAD_PRACTICE_LIST_DIFF_NAME_SUCCESS = 'practices/LOAD_PRACTICE_LIST_DIFF_NAME_SUCCESS';
const LOAD_PRACTICE_LIST_DIFF_NAME_FAIL = 'practices/LOAD_PRACTICE_LIST_DIFF_NAME_FAIL';

const LOAD_PRACTICE_LIST_SUCCESS = 'practices/LOAD_PRACTICE_LIST_SUCCESS';
const LOAD_PRACTICE_LIST_FAIL = 'practices/LOAD_PRACTICE_LIST_DIFF_NAME_FAIL';

const LOAD_PRACTICE_OPTIONS_SUCCESS = 'practices/LOAD_PRACTICE_OPTIONS_SUCCESS';
const LOAD_PRACTICE_OPTIONS_FAIL = 'practices/LOAD_PRACTICE_OPTIONS_FAIL';

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  loading: false,
  practiceList: [],
  practiceListArray: [],
  openHourList: null,
  weatherList: null,
  dbDuplicatePractices: [],
  differPracticeNames: [],
  practiceOptions: []
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('practiceList', action.res);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('schedule', null);

    case LOAD_WEATHER_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('weatherList', action.res);

    case LOAD_WEATHER_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('weatherList', null);

    case LOAD_OPENING_HOURS_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('openHourList', action.res);

    case LOAD_OPENING_HOURS_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('openHourList', null);
    case LOAD_PRACTICE_LIST_DIFF_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('dbDuplicatePractices', action.res);

    case LOAD_PRACTICE_LIST_DIFF_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('dbDuplicatePractices', null);

    case LOAD_PRACTICE_LIST_DIFF_NAME_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('differPracticeNames', action.res);

    case LOAD_PRACTICE_LIST_DIFF_NAME_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('differPracticeNames', null);

    case LOAD_PRACTICE_LIST_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('practiceListArray', action.res);

    case LOAD_PRACTICE_LIST_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('practiceListArray', null);

    case LOAD_PRACTICE_OPTIONS_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('practiceOptions', action.res);

    case LOAD_PRACTICE_OPTIONS_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('practiceOptions', []);

    default:
      return state;
  }
};

export const getPracticeInfo = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`/practicesInfo/getPractices`);
    dispatch({ type: LOAD_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getPracticeList = () => async (dispatch, getState, api) => {
  try {
    let res = await api.get(`/practicesInfo/getPracticeList`);
    let dbListDupNamePractices = {};
    let dbListDupName = {};
    res.forEach((item) => {
      if (item.practice.toLowerCase() !== item.practiceDBName.toLowerCase()) {
        dbListDupNamePractices = Object.assign(dbListDupName, {
          [`${item.practiceDBName.toLowerCase()}`]: item.practice.toLowerCase()
        });
      }
    });
    dispatch({ type: LOAD_PRACTICE_LIST_DIFF_SUCCESS, res: dbListDupNamePractices });
    let dbListDiffName = {}
    let dbListDffDupName = {};
    res.forEach((item) => {
      if (item.practice.toLowerCase() !== item.practiceDBName.toLowerCase()) {
        dbListDiffName = Object.assign(dbListDffDupName, {
          [`${item.practiceDBName.toLowerCase()}`]: item.practice.split(" ").join("").toLowerCase()
        });
      }
    });
    dispatch({ type: LOAD_PRACTICE_LIST_DIFF_NAME_SUCCESS, res: dbListDffDupName });
    dispatch({ type: LOAD_PRACTICE_LIST_SUCCESS, res: res })
    return res;
  } catch (err) {
    console.log('error found on get practice list.', err);
    return err;
  }
};

export const getRegionList = () => async (dispatch, getState, api) => {
  try {
    let res = await api.get(`/practicesInfo/regions`);
    return res;
  } catch (err) {
    console.log('error found on get practice list.', err);
    return err;
  }
};


export const weatherInfo = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`practicesInfo/weather`);
    dispatch({ type: LOAD_WEATHER_SUCCESS, res: res });
    return res;
  } catch (err) {
    console.log('error: resres', err);
    dispatch({ type: LOAD_WEATHER_FAIL, error: err.message });
  }
};

export const getOpeningHours = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`practicesInfo/getOpeningHours`);
    dispatch({ type: LOAD_OPENING_HOURS_SUCCESS, res: res });
    return res;
  } catch (err) {
    console.log('error: resres', err);
    dispatch({ type: LOAD_OPENING_HOURS_FAIL, error: err.message });
    return false;
  }
};

export const getPracticeOptions = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`/practicesInfo/getPracticeOptions`);
    dispatch({ type: LOAD_PRACTICE_OPTIONS_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_PRACTICE_OPTIONS_FAIL, error: err.message });
  }
};



